export const CLEAR_CBT = 'CLEAR_CBT';
export const SET_CBT = 'SET_CBT';
export const setCBT = data => ({ type: SET_CBT, data });
export const clearCBT = () => ({ type: CLEAR_CBT });
